(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.stickyHeaderType = this.getAttribute('data-sticky-type');
      this.headerIsAlwaysSticky = this.stickyHeaderType === 'always';
      this.headerUsesScrollSticky = this.stickyHeaderType === 'reduce-logo-size' || this.stickyHeaderType === 'on-scroll-up';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky || this.headerUsesScrollSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.scrollHideThreshold = 88;
      this.scrollRevealThreshold = 64;
      this.topResetThreshold = 6;
      this.scrollAnchorTop = 0;
      this.lastScrollDirection = 0;
      this.headerIsHidden = this.header.classList.contains('shopify-section-header-hidden');
      this.preventReveal = false;
      this.hideAnimationFrame = null;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop <= this.topResetThreshold) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
        this.scrollAnchorTop = 0;
        this.lastScrollDirection = 0;
        this.currentScrollTop = 0;
        this.headerIsHidden = false;
        this.preventHide = false;
        this.preventReveal = false;
        return;
      }

      const scrollDirection = scrollTop > this.currentScrollTop ? 1 : scrollTop < this.currentScrollTop ? -1 : 0;

      if (!scrollDirection) return;

      if (scrollDirection !== this.lastScrollDirection) {
        this.lastScrollDirection = scrollDirection;
        this.scrollAnchorTop = this.currentScrollTop;
      }

      const travelledDistance = Math.abs(scrollTop - this.scrollAnchorTop);

      if (scrollDirection > 0) {
        if (travelledDistance < this.scrollHideThreshold) {
          this.currentScrollTop = scrollTop;
          return;
        }

        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        if (!this.headerIsHidden) {
          requestAnimationFrame(this.hide.bind(this));
        }
        this.scrollAnchorTop = scrollTop;
      } else if (scrollDirection < 0) {
        if (travelledDistance < this.scrollRevealThreshold) {
          this.currentScrollTop = scrollTop;
          return;
        }

        this.header.classList.add('scrolled-past-header');
        if (!this.headerIsHidden) {
          this.scrollAnchorTop = scrollTop;
        } else if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
          this.scrollAnchorTop = scrollTop;
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.clearHideAnimationFrame();
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.hideAnimationFrame = requestAnimationFrame(() => {
        this.header.classList.add('shopify-section-header-hidden');
        this.headerIsHidden = true;
        this.hideAnimationFrame = null;
      });
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal(waitForAnimation = false) {
      if (this.headerIsAlwaysSticky) return Promise.resolve();
      this.clearHideAnimationFrame();

      const shouldWaitForAnimation = waitForAnimation && this.header.classList.contains('shopify-section-header-hidden');

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.headerIsHidden = false;

      if (!shouldWaitForAnimation) return Promise.resolve();

      return this.waitForRevealAnimation();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.clearHideAnimationFrame();
      this.header.classList.remove('shopify-section-header-hidden', 'animate');
      if (this.headerUsesScrollSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      } else {
        this.header.classList.remove('shopify-section-header-sticky');
      }
      this.headerIsHidden = false;
    }

    clearHideAnimationFrame() {
      if (!this.hideAnimationFrame) return;
      cancelAnimationFrame(this.hideAnimationFrame);
      this.hideAnimationFrame = null;
    }

    getHeaderTransitionDuration() {
      const computedStyle = window.getComputedStyle(this.header);
      const durations = computedStyle.transitionDuration.split(',').map((value) => value.trim());
      const delays = computedStyle.transitionDelay.split(',').map((value) => value.trim());

      const parseTimeToMs = (value) => {
        if (!value) return 0;
        if (value.endsWith('ms')) return Number.parseFloat(value);
        if (value.endsWith('s')) return Number.parseFloat(value) * 1000;
        return Number.parseFloat(value) || 0;
      };

      return durations.reduce((longestDuration, durationValue, index) => {
        const duration = parseTimeToMs(durationValue);
        const delay = parseTimeToMs(delays[index] || delays[delays.length - 1] || '0s');
        return Math.max(longestDuration, duration + delay);
      }, 0);
    }

    waitForRevealAnimation() {
      return new Promise((resolve) => {
        const transitionDuration = this.getHeaderTransitionDuration();

        if (!transitionDuration) {
          resolve();
          return;
        }

        const handleTransitionEnd = (event) => {
          if (event.target !== this.header || event.propertyName !== 'transform') return;
          cleanup();
          resolve();
        };

        const cleanup = () => {
          window.clearTimeout(transitionFallback);
          this.header.removeEventListener('transitionend', handleTransitionEnd);
        };

        const transitionFallback = window.setTimeout(() => {
          cleanup();
          resolve();
        }, transitionDuration + 80);

        this.header.addEventListener('transitionend', handleTransitionEnd);
      });
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
